import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getContactList() {
    yield* takeEvery("CONTACT/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/contact${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { contacts, contact } = result;
                if (action.id) {
                    yield put({ type: 'CONTACT/SET', contact });
                } else {
                    yield put({ type: 'CONTACTS/SET', contacts });
                }
            } else {
                yield put({ type: 'CONTACT/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'CONTACT/FETCH_FAILED', e });
        }
    });
}



// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/contactEmailList.js